"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationDetails = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const useDateFormatter_1 = require("../../../util/useDateFormatter");
const NotificationDetailsTemplateRender_1 = require("./NotificationDetailsTemplateRender");
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    container: {
        background: theme.palette.background.paper,
        height: '100%',
    },
    scrollContainer: {
        overflow: 'auto',
        height: '100%',
    },
}));
const NotificationDetails = ({ selectedNotification }) => {
    const classes = useStyles();
    const { formatDateTime } = (0, useDateFormatter_1.useDateFormatter)();
    const theme = (0, silhouette_core_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, direction: "column", className: classes.container, wrap: "nowrap", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { px: 3, py: 2, borderBottom: `1px solid ${theme.palette.divider}`, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "body2", children: formatDateTime(selectedNotification.createdAt) }) }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { className: classes.scrollContainer, children: (0, jsx_runtime_1.jsx)(NotificationDetailsTemplateRender_1.NotificationDetailsTemplateRender, { notificationID: selectedNotification.id, status: selectedNotification.status }) })] }));
};
exports.NotificationDetails = NotificationDetails;
//# sourceMappingURL=NotificationDetails.js.map